import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import auth from "../../services/authService";
import { toast } from "react-toastify";

export default class loginByMobile extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      isLoading: false,
    };
  }
  state = {
    data: { mobile: "", password: "" },
    errors: {},
  };

  schema = {
    mobile: Joi.string()
      .required()
      .error(new Error("شماره تلفن همراه اجباری است")),
    password: Joi.string().required().error(new Error("رمز عبور اجباری است")),
  };

  doSubmit = async () => {
    const { data } = this.state;
    try {
      await auth.loginByMobile(data.mobile, data.password);
      window.location = "/";
    } catch (ex) {
      if (ex.code !== "ERR_NETWORK") {
        toast.error(ex.response.data.Message);
      }
      const isLoading = false;
      this.setState({ isLoading: isLoading });
    }
  };

  render() {
    if (auth.getCurrentUser()) return (window.location = "/");
    return (
      <div id="loginByMobile">
        <div className="row justify-content-center">
          <form
            onSubmit={this.handleSubmit}
            className="row justify-content-center"
            action="/"
          >
            <div className="col-11  mb-4">
              {this.renderInput(
                "mobile",
                "",
                "شماره تلفن همراه",
                "form-control form-control-lg"
              )}
            </div>
            <div className="col-11  mb-4">
              <small style={{ color: "red" }}>حساس به حروف کوچک و بزرگ</small>
              {this.renderInput(
                "password",
                "",
                "رمز عبور",
                "form-control form-control-lg"
              )}
            </div>
            <div className="d-grid  col-11 mx-auto">
              {this.renderButtonWithSpinner("ورود", "btn btn-primary")}
            </div>
          </form>
        </div>
      </div>
    );
  }
}
